export class SingleSiteAnalysisInputModel {
    constructor(public studyId?: number,
                public environmentFactor?: number,
                public selectedTraitIds?: number[],
                public selectedCovariateIds?: number[],
                public instanceIds?: number[],
                public breedingViewAnalysisName?: string,
                public designTypeId?: number,
                public replicatesFactor?: number,
                public blockFactor?: number,
                public rowFactor?: number,
                public columnFactor?: number,
                public genotypesFactor?: number
    ) {
    }
}
